<template>
  <div>
    <TopMenu :leftOption="'back-dashboard'" :title="$t('Jukebox')">
      <template slot="right">
        <span><a href="#" @click.prevent="jukeboxSave()"><FontAwesomeIcon icon="check" class="text-success"/></a></span>
      </template>
    </TopMenu>
    <div class="view">
      <transition name="fade" appear>
        <div>
          <div class="p-4">{{$t('Allowed Songs')}}:</div>
          <div class="px-4 mb-4">
            <div class="select-wrapper">
              <select v-model="selectedOption" class="custom-select bg-dark border-0 ">
                <option v-for="option in optionsList" :key="option.value" :value="option.value">{{option.label}}</option>
              </select>
            </div>
          </div>
          <div class="px-1 mb-1 mt-4">
            <button
              @click.prevent="getJukeboxCode()"
              class="btn btn-dark btn-block text-center text-primary clickable px-4 "
            >{{$t('Get code')}}</button>
          </div>
          <Modal
            :displayModal="displayCodeModal"
            :onClose="() => { jukeboxCode = null; displayCodeModal = false; }"
          >
            <template slot="body">
              <span>{{$t('Your code is')}}:</span>
              <p class="h1 py-3">{{ jukeboxCode }}</p>
            </template>
            <template slot="footer"><span></span></template>
          </Modal>
          <div
            v-for="playlist in playlists"
            :style="{ display: selectedOption === 'select' ? 'block' : 'none' }"
            class="px-1 mb-1 font-button"
            :key="playlist.id"
            @click.prevent="togglePlaylist(playlist.id)"
          >
            <div class="bg-dark px-4 py-3 d-block d-flex justify-content-start align-items-center rounded clickable">
              <span class="mr-3">
              <FontAwesomeIcon icon="chevron-right" class="text-primary" /></span><span>{{ playlist.name }}</span>
              <span :style="{ display: selectedPlaylists.has(playlist.id) ? 'inline' : 'none' }" class="ml-auto text-primary">
                <FontAwesomeIcon icon="check" />
              </span>
              <span :style="{ display: !selectedPlaylists.has(playlist.id) ? 'inline' : 'none' }" class="ml-auto text-danger">
                <FontAwesomeIcon icon="times" />
              </span>
            </div>
          </div>
        </div>
      </transition>
      <OverlayLoader :displayOverlay="loadingBoxStatus || loadingPlaylists || fetchingJukeboxCode || updatingCurrentBox" />
    </div>
  </div>
</template>

<script>
import musicboxClient from '@/utils/musicboxClient'
export default {

  name: 'Jukebox',

  mounted () {
    this.loadingPlaylists = true
    musicboxClient
      .getPlaylists()
      .then(res => {
        this.playlists = res.data
      })
      .catch(e => {
        this.$notify.danger(this.$t('Failed to fetch playlists'))
      })
      .then(() => { this.loadingPlaylists = false })

    this.loadingBoxStatus = true
    musicboxClient
      .getBoxInfo(this.$store.state.audio.currentBox.uuid)
      .then(res => {
        if (res.data.jukebox_lists && res.data.jukebox_lists.length > 0) {
          res.data.jukebox_lists.forEach(jukeboxPlaylist => {
            this.selectedPlaylists.add(jukeboxPlaylist.id)
          })
        }
      })
      .catch(e => {
        this.$notify.danger(this.$t('Failed to get box data'))
      })
      .then(() => { this.loadingBoxStatus = false })
  },

  data () {
    return {
      optionsList: [
        { value: 'all', label: this.$t('Allow all songs') },
        { value: 'currentPlaylist', label: this.$t('Songs from current playlist') },
        { value: 'select', label: this.$t('Select playlists') }
      ],
      selectedOption: 'all',
      loadingPlaylists: false,
      updatingCurrentBox: false,
      loadingBoxStatus: false,
      fetchingJukeboxCode: false,
      displayCodeModal: false,
      playlists: [],
      selectedPlaylists: new Set(),
      jukeboxCode: null
    }
  },

  methods: {
    jukeboxSave () {
      if (this.selectedOption === 'currentPlaylist') {
        this.enableCurrentPlaylist()
      } else if (this.selectedOption === 'select') {
        this.updateWithSelectedPlaylists()
      } else if (this.selectedOption === 'all') {
        this.updateWithSelectedPlaylists(true)
      }
    },
    enableCurrentPlaylist () {
      this.updatingCurrentBox = true
      musicboxClient
        .boxAllowCurrentPlaylist(this.$store.state.audio.currentBox.uuid, true)
        .then(res => {
          this.$notify.success(this.$t('Current playlist allowed'))
        })
        .catch(() => {
          this.$notify.danger(this.$t('Failed to allow current playlist'))
        })
        .then(() => { this.updatingCurrentBox = false })
    },
    updateWithSelectedPlaylists (all = false) {
      this.updatingCurrentBox = true
      musicboxClient
        .boxAllowPlaylists(
          this.$store.state.audio.currentBox.uuid,
          all ? this.playlists.map(playlist => playlist.id) : Array.from(this.selectedPlaylists)
        )
        .then(res => {
          this.$notify.success(this.$t('Playlists allowed'))
          const selectedNow = new Set()
          res.data.jukebox_list.forEach(jukeboxPlaylist => {
            selectedNow.add(jukeboxPlaylist.id)
          })
          this.selectedPlaylists = selectedNow
        })
        .catch(() => {
          this.$notify.danger(this.$t('Failed to allow selected playlist'))
        })
        .then(() => { this.updatingCurrentBox = false })
    },
    getJukeboxCode () {
      this.fetchingJukeboxCode = true
      musicboxClient
        .getJukeboxCode(this.$store.state.audio.currentBox.uuid)
        .then(res => {
          if (res.data.codes_created && res.data.codes_created.length > 0) {
            this.jukeboxCode = res.data.codes_created[0]
            this.displayCodeModal = true
          }
        })
        .catch(() => {
          this.$notify.danger(this.$t('Failed to get jukebox code'))
        })
        .then(() => { this.fetchingJukeboxCode = false })
    },
    togglePlaylist (playlistId) {
      if (this.selectedPlaylists.has(playlistId)) {
        this.selectedPlaylists.delete(playlistId)
      } else {
        this.selectedPlaylists.add(playlistId)
      }
      this.selectedPlaylists = new Set(this.selectedPlaylists)
    }
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Jukebox.vue